import React from 'react';
import {TerminalScreen} from 'src/v2/components/screen/TerminalScreen';
import {getStore} from 'src/v2/state/store';
import {message, useIntl} from '@sail/intl';

const messages = {
  title: message({
    id: 'crypto.payins.v2.canceled_screen.title',
    description: 'Title for screen when payment has been canceled/expired',
    defaultMessage: 'Your session timed out',
  }),

  subtitle: message<{
    businessName: React.ReactNode;
  }>({
    id: 'crypto.payins.v2.canceled_screen.subtitle',
    description: 'Subtitle for screen when payment has been canceled/expired',
    defaultMessage: 'Go back to {businessName} and try again.',
  }),
};

export const CanceledScreen = () => {
  const intl = useIntl();
  const store = getStore();
  const businessName = store.useSelector(
    (state) => state.merchantBranding.businessName,
  );

  return (
    <TerminalScreen
      title={intl.formatMessage(messages.title)}
      subtitleMessage={intl.formatMessage(messages.subtitle, {businessName})}
      isSuccess={false}
    />
  );
};
